<template>
    <div class="layout">
  
      <Navbar />
  
      <main class="content">
        <RouterView />
      </main>

      <Footer />

      <Whatsapp />
  
    </div>
  </template>
  
  <script>
  import Navbar from '@/components/layout/navbar/Navbar.vue'
  import Footer from '@/components/layout/footer/Footer.vue';
  import Whatsapp from '@/components/common/Whatsapp.vue';
  export default {
    name: 'DefaultLayout',
  
    components: {
      Navbar,
      Footer,
      Whatsapp
    }
  }
  </script>
  
  <style scoped>
  .layout {
    min-height: 100vh;
  }
  
  .content {
    width: 100%;
  }
  </style>